import action from "../action";
export const SET_VIEWER_WEB_URL = "SET_VIEWER_WEB_URL";
export const SET_WEB_URL = "SET_WEB_URL";

export const setViewerWebUrl = (data) =>
  action({
    type: SET_VIEWER_WEB_URL,
    data
  });
export const setWebUrl = (data) =>
  action({
    type: SET_WEB_URL,
    data
  });
